var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"gotop",class:_vm.show,attrs:{"title":"Go to top"},on:{"click":_vm.goToTop}},[_c('i',{staticClass:"fas fa-chevron-circle-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }